import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import moment from 'moment-timezone';

import Icon, { GLYPHS } from './Icon';
import WithApplePay from '../hoc/WithApplePay';
import { extendLocation } from '../utils/helpers';
import analytics from '../applicationServices/analytics/BookingAnalytics';


const WaitingListLink = ({ to, hasApplePay, service, date, time, timezone, barber, from, shop }) => {
  const proceedToCheckout = (isApplePay = false) => () => {
    analytics.proceedToCheckout({
      ...(from === 'barber' ? { barber: barber && barber.toJS() } : { service }),
      date,
      time: moment.tz(time, timezone).format('h:mmA'),
      isApplePay,
      hasApplePay,
      waitingList: true,
      shop,
    });

    return true;
  };

  return (
    <div className="layout layout--auto layout--center u-mt">
      <div className="layout__item">
        <Link
          onClick={proceedToCheckout()}
          to={to}
          className="c-btn c-btn--primary c-btn--small"
        >
          Put me on a waiting list
        </Link>
      </div>

      { hasApplePay && false && /* TODO: Reenable applePay link */
        <div className="layout__item">
          <Link
            onClick={proceedToCheckout(true)}
            to={extendLocation(to, { query: { applePay: true } })}
            className="c-btn c-btn--default c-btn--small"
          >
            <Icon glyph={GLYPHS.APPLE} size="large" /> Put me on a waiting list
          </Link>
        </div>
      }
    </div>
  );
};
WaitingListLink.propTypes = {
  to: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.object,
    }),
  ]).isRequired,
  from: PropTypes.string.isRequired,
  hasApplePay: PropTypes.bool.isRequired,
  service: PropTypes.string.isRequired,
  barber: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  shop: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  date: PropTypes.string.isRequired,
  time: PropTypes.string.isRequired,
  timezone: PropTypes.string.isRequired,
};

export default WithApplePay(WaitingListLink);



// WEBPACK FOOTER //
// ./src/app/components/WaitingListLink.jsx